<template>
  <!-- <b-card-code :title="$t('user.mobile')"> -->
  <div>
    <b-form
        ref="form"
        :style="{ height: trHeight }"
        class="mt-0"
        @submit.prevent="repeateAgain"
    >
      <!-- :style="{ height: trHeight }" -->
      <!-- Row Loop -->
      <b-row v-for="(userPermissionRoom, index) in userPermissionRooms" :key="index" ref="row">
        <b-col lg="2" sm="4" xl="2">
          <b-form-group
              :label="$t('permissions.unit')"
              :label-for="`userPermissionRooms-unit${index}`"
              :invalid-feedback="
              invalidPermissionUnits(index)
                ? $t(`validation.${invalidPermissionUnits(index)}`,{
                    field: $t('permissions.unit'),
                  })
                : ''
            "
              :state="
              v.userPermissionRooms.$each.$iter[index].permissionRoomId.$dirty
                ? !v.userPermissionRooms.$each.$iter[index].permissionRoomId.$invalid
                : null
            "
          >
            <my-v-select
                :key="userPermissionRoom.unitId"
                :translate="false"
                v-model="userPermissionRoom.unitId"
                :concat-label="['title']"
                :searchable="true"
                :filterable="true"
                :options="(units && units.length) ? units : []"
                :multiple="false"
                @input="searchRooms(index)"
                :id="`userPermissionRooms-unit${index}`"
            />
<!--            <b-form-select-->
<!--                :id="`userPermissionRooms-unit${index}`"-->
<!--                v-model="userPermissionRoom.unitId"-->
<!--                text-field="title"-->
<!--                value-field="_id"-->
<!--                :state="-->
<!--              v.userPermissionRooms.$each.$iter[index].unitId.$dirty-->
<!--                ? !v.userPermissionRooms.$each.$iter[index].unitId.$invalid-->
<!--                : null-->
<!--            "-->
<!--                @change="searchRooms(index)"-->
<!--            >-->
<!--              <b-form-select-option-->
<!--                  v-for="u in units"-->
<!--                  :key="u._id"-->
<!--                  :value="u._id"-->
<!--              >-->
<!--                <div-->
<!--                    class="d-flex justify-content-between"-->
<!--                    style="background-color: red"-->
<!--                >-->
<!--                  <span>{{ u.title }}</span>-->
<!--                </div>-->
<!--              </b-form-select-option>-->
<!--            </b-form-select>-->
          </b-form-group>
        </b-col>
        <b-col lg="2" sm="4" xl="2">
          <b-form-group
              :label="$t('permissions.room')"
              :label-for="`userPermissionRooms-room${index}`"
              :invalid-feedback="
              invalidPermissionRoom(index)
                ? $t(`validation.${invalidPermissionRoom(index)}`,{
                    field: $t('permissions.room'),
                  })
                : ''
            "
              :state="
              v.userPermissionRooms.$each.$iter[index].roomId.$dirty
                ? !v.userPermissionRooms.$each.$iter[index].roomId.$invalid
                : null
            "
          >
            <my-v-select
                :key="userPermissionRoom.roomId"
                :translate="false"
                v-model="userPermissionRoom.roomId"
                :concat-label="['title']"
                :searchable="true"
                :filterable="true"
                :options="(userPermissionRepeaterRooms[index] && userPermissionRepeaterRooms[index].length) ? userPermissionRepeaterRooms[index] : []"
                :multiple="false"

                :id="`userPermissionRooms-room${index}`"
            />
<!--            <b-form-select-->
<!--                :state="-->
<!--              v.userPermissionRooms.$each.$iter[index].roomId.$dirty-->
<!--                ? !v.userPermissionRooms.$each.$iter[index].roomId.$invalid-->
<!--                : null-->
<!--            "-->
<!--                :id="`userPermissionRooms-room${index}`"-->
<!--                v-model="userPermissionRoom.roomId"-->
<!--                text-field="title"-->
<!--                value-field="_id"-->
<!--            >-->
<!--              <b-form-select-option-->
<!--                  v-for="r in userPermissionRepeaterRooms[index]"-->
<!--                  :key="r._id"-->
<!--                  :value="r._id"-->
<!--              >-->
<!--                <div-->
<!--                    class="d-flex justify-content-between"-->
<!--                    style="background-color: red"-->
<!--                >-->
<!--                  <span>{{ r.title }}</span>-->
<!--                </div>-->
<!--              </b-form-select-option>-->
<!--            </b-form-select>-->
          </b-form-group>
        </b-col>
        <!-- Item Mobile -->
        <b-col lg="3" sm="5" xl="2">
          <b-form-group
              :label="$t('permissions.roomPermissions')"
              :label-for="`userPermissionRooms-roomPermissions${index}`"
              :invalid-feedback="
              invalidPermissionRoomId(index)
                ? $t(`validation.${invalidPermissionRoomId(index)}`,{
                    field: $t('permissions.roomPermissions'),
                  })
                : ''
            "
              :state="
              v.userPermissionRooms.$each.$iter[index].permissionRoomId.$dirty
                ? !v.userPermissionRooms.$each.$iter[index].permissionRoomId.$invalid
                : null
            "
          >
            <my-v-select
                :key="userPermissionRoom.permissionRoomId"
                :translate="false"
                v-model="userPermissionRoom.permissionRoomId"
                :concat-label="['title']"
                :searchable="true"
                :filterable="true"
                :options="(permissionRooms && permissionRooms.length) ? permissionRooms : []"
                :multiple="false"
                :id="`userPermissionRooms-roomPermissions${index}`"
            />
<!--            <b-form-select-->
<!--                :state="-->
<!--              v.userPermissionRooms.$each.$iter[index].permissionRoomId.$dirty-->
<!--                ? !v.userPermissionRooms.$each.$iter[index].permissionRoomId.$invalid-->
<!--                : null-->
<!--            "-->
<!--                :id="`userPermissionRooms-roomPermissions${index}`"-->
<!--                v-model="userPermissionRoom.permissionRoomId"-->
<!--                :options="permissionRooms"-->
<!--                text-field="title"-->
<!--                value-field="_id"-->
<!--            >-->
<!--                                          <b-form-select-option-->
<!--                                              v-for="c in permissionRooms"-->
<!--                                              :key="c.dialCode"-->
<!--                                              :value="permissionUnits[index]._id"-->
<!--                                          >-->
<!--                                            <div-->
<!--                                                style="background-color: red"-->
<!--                                                class="d-flex justify-content-between"-->
<!--                                            >-->
<!--                                              <span>({{ c.dialCode }})</span>-->
<!--                                              <span>{{ c.title }}</span>-->
<!--                                            </div>-->
<!--                                          </b-form-select-option>-->
<!--            </b-form-select>-->
          </b-form-group>
        </b-col>
        <!-- Remove and Add Button -->
        <b-col>
          <div class="action-buttons has-margin sm">
            <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="white"
                @click="removeItem(index)"

            >
              <b-icon icon="x-circle"
                      scale="2"
                      variant="danger"
              ></b-icon>
            </b-button>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="white"
                @click="repeateAgain"
                v-if="index === userPermissionRooms.length - 1"
            >
              <b-icon icon="plus-circle"
                      scale="2"
                      variant="success"
              ></b-icon>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
  <!--
    <template #code>
      {{ codeBasic }}
    </template> -->
  <!-- </b-card-code> -->
</template>

<script>
import BCardCode from "@core/components/b-card-code";
import {heightTransition} from "@/mixins/ui/transition";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BFormSelect,
  BFormSelectOption,
  BFormText,
} from "bootstrap-vue";
import {mapGetters} from "vuex";
import Ripple from "vue-ripple-directive";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
// import { codeBasic } from "./code";

export default {
  components: {
    MyVSelect,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BFormText,
  },
  directives: {
    Ripple,
  },
  props: ["v"],
  data() {
    return {
      nextTodoId: 2,
      rowRooms: [],
      unit: null
    };
  },
  mixins: [heightTransition],
  computed: {
    ...mapGetters({
      permissionRooms: "permissionRooms/permissionRooms",
      units: "units/units",
      // rooms: "rooms/rooms",
    }),

    userPermissionRooms: {
      set(userPermissionRooms) {
        this.$store.commit("permissions/SET_USER_PERMISSION_ROOMS", userPermissionRooms);
      },
      get() {
        return this.$store.getters["permissions/userPermissionRooms"];
      },
    },
    userPermissionRepeaterRooms: {
      set(userPermissionRepeaterRooms) {
        this.$store.commit("permissions/SET_USER_PERMISSION_REPEATER_ROOMS", userPermissionRepeaterRooms);
      },
      get() {
        return this.$store.getters["permissions/userPermissionRepeaterRooms"];
      },
    },
  },

  mounted() {
    this.initTrHeight();
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    invalidPermissionUnits(index) {
      var error = "";
      if (!this.v.userPermissionRooms.$each.$iter[index].unitId.$dirty) return error;
      if (
          !this.v.userPermissionRooms.$each.$iter[index].unitId.required
      ) {
        error = "required";
        return error;
      }
      return error;
    },
    invalidPermissionRoom(index) {
      var error = "";
      if (!this.v.userPermissionRooms.$each.$iter[index].roomId.$dirty) return error;
      if (
          !this.v.userPermissionRooms.$each.$iter[index].roomId.required
      ) {
        error = "required";
        return error;
      }
      return error;
    },
    invalidPermissionRoomId(index) {
      var error = "";
      if (!this.v.userPermissionRooms.$each.$iter[index].permissionRoomId.$dirty) return error;
      if (
          !this.v.userPermissionRooms.$each.$iter[index].permissionRoomId.required
      ) {
        error = "required";
        return error;
      }
      return error;
    },
    // invalidFeedbackMobile(index) {
    //   var error = "";
    //   if (!this.v.mobiles.$each.$iter[index].mobile.$dirty) return error;
    //
    //   if (!this.v.mobiles.$each.$iter[index].mobile.reqiured) {
    //     error = "required";
    //     return error;
    //   }
    //   if (!this.v.mobiles.$each.$iter[index].mobile.mobileValidation) {
    //     error = "invalid";
    //     return error;
    //   }
    //   return error;
    // },
    searchRooms(index) {
      this.$store.dispatch('rooms/searchRoom', {
        unitId: this.userPermissionRooms[index].unitId,
        status: 'active'
      }).then((res) => {

        this.userPermissionRepeaterRooms[index] = null;
        this.$set(this.userPermissionRepeaterRooms, index, [...res])
      })
    },
    repeateAgain() {
      this.userPermissionRooms.push({
        // id: (this.nextTodoId += this.nextTodoId),
        roomId: "",
        permissionRoomId: "",
      });
      // this.searchRooms(this.userPermissionRooms.roomId.unitId)
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.userPermissionRooms.splice(index, 1);
      if (index !== 0) {

        this.trTrimHeight(this.$refs.row[0].offsetHeight);
      }else{
        this.userPermissionRooms.push({
          roomId: "",
          permissionRoomId: "",
        })
      }
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
  },
  // validations() {
  //   return {
  //     mobiles: {
  //       $each: {
  //         mobile_number: {
  //           required,
  //           mobileValidation: (value) => this.mobileValidation(value),
  //         },
  //       },
  //     },
  //   };
  // },
};
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
